export default __webpack_public_path__ + "static/media/mood_swings@2x.48c83209.jpg";